export const chart = {
	selector: {
		graphicsContainer: '.graphics-container',
	},
}
